// extracted by mini-css-extract-plugin
export default {"ScreenLGMin":"(min-width: 1200px)","ScreenXLMin":"(min-width: 1600px)","wave":"Ga0f718","waves":"G8a7500"};